import React from "react";

type CellValue = "X" | "O" | null;

interface CellProps {
  value: CellValue;
  onClick: () => void;
  isWinning: boolean;
  disabled: boolean;
  index: number;
}

export function Cell({ value, onClick, isWinning, disabled, index }: CellProps) {
  const glowClass = isWinning
    ? value === "X"
      ? "cell-glow-x"
      : "cell-glow-o"
    : "";

  const borderClasses = [
    index % 3 !== 2 ? "border-r" : "",
    index < 6 ? "border-b" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      onClick={onClick}
      disabled={disabled || value !== null}
      aria-label={
        value ? `Cell ${index + 1}: ${value}` : `Cell ${index + 1}: empty`
      }
      className={`
        relative flex items-center justify-center
        w-[min(28vw,120px)] h-[min(28vw,120px)]
        border-[var(--color-grid-line)]
        ${borderClasses}
        transition-all duration-200
        ${!disabled && !value ? "hover:bg-[var(--color-surface-hover)] cursor-pointer" : ""}
        ${disabled && !value ? "cursor-default" : ""}
        ${value ? "cursor-default" : ""}
        ${glowClass}
        focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-[var(--color-x)]
      `}
      style={{ background: isWinning ? "var(--color-surface)" : "transparent" }}
    >
      {value && (
        <span
          className={`
            marker-enter
            font-[var(--font-mono)] font-bold
            text-[min(14vw,64px)] leading-none select-none
          `}
          style={{
            fontFamily: "var(--font-mono)",
            color: value === "X" ? "var(--color-x)" : "var(--color-o)",
            textShadow:
              value === "X"
                ? "0 0 20px var(--color-x-glow)"
                : "0 0 20px var(--color-o-glow)",
          }}
        >
          {value}
        </span>
      )}
    </button>
  );
}
